import React, {useEffect, useRef, useState} from "react";
import { SelectUsersIndicator } from "components/Select";
import {addIndicatorUser, getIndicatorById} from "services/Indicators.service";
import { format, parseISO } from "date-fns";
import {swalQuestion} from "components/Swal";
import {useMutation, useQueryClient} from "react-query";
import {toast} from "react-toastify";
import {setLog} from "services/Logs.service";
import {useUser} from "store/providers/app";
import {changeArray} from "utils/functions";
import {sendEmail} from "../../services/Mail.service";

export const UsersEdit = ({indicatorId, usersIndicator}) => {
    const [leader, setLeader] = useState();
    const [respondents, setRespondents] = useState([]);
    const [leaderDeadline, setLeaderDeadline] = useState();
    const [respondentsDeadline, setRespondentsDeadline] = useState();
    const [loading, setLoading] = useState(true);
    const [loadingButton, setLoadingButton] = useState(false);

    const {user} = useUser()
    const queryClient = useQueryClient()

    useEffect(() => {
        if (usersIndicator.length > 0) {
            const filterLeader = usersIndicator.filter(user => user.type === 1)
            const filterRespondents = usersIndicator.filter(user => user.type === 2)

            if(filterLeader.length > 0) {
                const deadline = parseISO(filterLeader[0].deadline)
                const dateFormat = format(deadline, 'yyyy-MM-dd')
                setLeaderDeadline(dateFormat)
            }

            if(filterRespondents.length > 0) {
                const deadline = parseISO(filterRespondents[0].deadline)
                const dateFormat = format(deadline, 'yyyy-MM-dd')
                setRespondentsDeadline(dateFormat)
            }

            setLeader(changeArray(filterLeader))
            setRespondents(changeArray(filterRespondents))
        }

        setLoading(false)
    }, [usersIndicator])

    const toastId = React.useRef(null);

    const saveUsers = async (type) => {

        setLoadingButton(true)
        toastId.current = toast.loading("Processando...", { type: toast.TYPE.DEFAULT, autoClose: false });

        const users = type === 1 ? leader : respondents
        const typeLabel = type === 1 ? 'Líder ESG' : 'Respondente'
        const newUsers = []
        const deadlineDate = type === 1 ? leaderDeadline : respondentsDeadline

        const indicator = await getIndicatorById(indicatorId, true)

        for (const user of users) {
            const deadline = parseISO(deadlineDate)
            const dateFormat = format(deadline, 'yyyy-MM-dd')
            const dateFormatMail = format(deadline, 'dd/MM/yyyy')

            const dataMail = {
                senderName: user.username,
                userUuid: user.value,
                indicatorId: indicatorId,
                deadline: dateFormat,
                content: 'Você foi adicionado como ' + typeLabel + ', no indicador ' + indicator.titulo + ' com prazo de resposta até  ' + dateFormatMail,
            }

            await sendEmail(dataMail)

            newUsers.push({
                indicator: indicatorId,
                user: user.value,
                deadline: dateFormat,
                type: type
            })
        }

            await addIndicatorUser(
                {
                    indicator: indicatorId,
                    users: newUsers,
                    type: type
                 })
                .then(response => {
                    setLog({
                        'title': 'UPDATE_RESPONSIBLE_INDICATOR',
                        'description': 'Alterou o grupo ' + typeLabel + 'do indicador' + indicator.titulo,
                        'username': user.username,
                        'indicator_id': indicatorId,
                        'extradata': newUsers
                    });

                    toast.update(toastId.current, {
                        render: () => <div>{response.message}</div>,
                        type: toast.TYPE.SUCCESS,
                        autoClose: 5000,
                        isLoading: false
                    });
                    setLoadingButton(false)
                })
                .catch((error) => console.log('Erro ao salvar usuarios => ', error))

    }

    const userMutations = useMutation(async (type) => {
            return saveUsers(type)
        }, {
            onSuccess: () => {
                queryClient.invalidateQueries(['indicators_list'])
            },
            onError: () => {
                toast.error('Erro ao salvar usuário');
            }
        }
    )

    const handleSave = async (type) => {
        if(type === 2) {
            if(!respondents.length) {
                toast.warning('Selecione ao menos 1 respondente');
                return
            }

            if(!respondentsDeadline) {
                toast.warning('Informe o prazo de resposta para o(s) respondente(s)');
                return
            }
        }

        if(type === 1) {
            if(!leader) {
                toast.warning('Selecione ao menos 1 Líder ESG');
                return
            }

            if(!leaderDeadline) {
                toast.warning('Informe o prazo de resposta para o Líder ESG');
                return
            }
        }

        swalQuestion(`<b>Deseja salvar as alterações?</b>`)
            .then((result) => {
                if (result.isConfirmed) {
                    userMutations.mutate(type)
                }
            })
    }

    return (
        <div className="row g-3">
            {loading ? 'Aguarde... ' :
                <>
                    <div className="col-12">
                        <div className="row align-items-baseline">
                            <div className="col-12 col-md-7">
                                <label className="form-label">Líder ESG</label>
                                <SelectUsersIndicator
                                    profile={2}
                                    onChangeUser={(data) => setLeader(data)}
                                    isMulti={true}
                                    defaultValues={leader}
                                />
                            </div>
                            <div className="col-10 col-md-4">
                                <label className="form-label">Prazo</label>
                                <input
                                    name="deadline-leader"
                                    type="date"
                                    className="form-control"
                                    onChange={(e) => setLeaderDeadline(e.target.value)}
                                    value={leaderDeadline || ''}
                                />
                            </div>
                            <div className="col-1 align-self-end ps-0">
                                <button
                                    className="btn btn-success"
                                    type="button"
                                    onClick={() => handleSave(1)}
                                    disabled={loadingButton}
                                >
                                     <i className="bi bi-check-lg"/>
                                </button>
                            </div>
                        </div>
                    </div>

                    <div className="col-12">

                        <div className="row">
                            <div className="col-12 col-md-7">
                                <label className="form-label">Respondentes</label>
                                <SelectUsersIndicator
                                    profile={3}
                                    isMulti={true}
                                    onChangeUser={(e) => setRespondents(e)}
                                    defaultValues={respondents}
                                />
                            </div>
                            <div className="col-10 col-md-4">
                                <label className="form-label">Prazo</label>
                                <input
                                    name="deadline-leader"
                                    type="date"
                                    className="form-control"
                                    onChange={(e) => setRespondentsDeadline(e.target.value)}
                                    value={respondentsDeadline || ''}
                                />
                            </div>
                            <div className="col-1 align-self-end ps-0">
                                <button
                                    className="btn btn-success"
                                    type="button"
                                    onClick={() => handleSave(2)}
                                    disabled={loadingButton}
                                >
                                    <i className="bi bi-check-lg"/>
                                </button>
                            </div>
                        </div>
                    </div>
                </>
            }
        </div>
    )
}